import React, { Component } from 'react';
import L from 'leaflet';
import 'leaflet.markercluster';
import omnivore from 'leaflet-omnivore';
import PropTypes from 'prop-types'; // ES6
import { connect } from 'react-redux';
import _ from 'lodash';
import { Spin } from 'antd';

import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import AvisMapaSelectorMeteors from './avisMapaSelectorMeteors';
import AvisMapaLlegenda from './avisMapaLlegenda';
import { generarCapaBase } from '../commons/mapa';
import icones from '../../images/avis';

import { avisVisualitzacioSeleccionarAvis, avisVisualitzacioActualitzarIdsAvisosPelMapa } from '../../actions';

import obtenirConfiguracio from '../../configuracioEntorns';

const fetch = require('node-fetch');

const { BUCKET_S3_URL, FOLDER_TOPOJSON } = obtenirConfiguracio();
const urlTopoJsonMunicipis = `${BUCKET_S3_URL}/${FOLDER_TOPOJSON}/municipis.json`;
const urlTopoJsonComarques = `${BUCKET_S3_URL}/${FOLDER_TOPOJSON}/comarques.json`;

const nivellZoomMostrarClusters = 10;
const coordenadesCentreCatalunya = { latitud: 41.71669, longitud: 1.61224 };

/**
 * Agrupa els avisos pel codi INE del municipi. L'estructura que retorna es la mateixa que la del lodash.
 * No es pot utilizar lodash directament perque l'atribut que agrupa esta en un segon nivell(munici.codiINE)
 * @param {Array} avisos
 */
const agruparAvisosPerMunicipi = (avisos) => {
	const avisosAgrupatsPerMunicipi = {};

	avisos.forEach((avis) => {
		if (!avisosAgrupatsPerMunicipi[avis.municipi.codiIne]) {
			avisosAgrupatsPerMunicipi[avis.municipi.codiIne] = [];
		}
		avisosAgrupatsPerMunicipi[avis.municipi.codiIne].push(avis);
	});

	return avisosAgrupatsPerMunicipi;
};

const transformarEnEstructuraMapa = (avisos) => {
	const avisosAgrupatsPerMunicipi = agruparAvisosPerMunicipi(avisos);

	Object.keys(avisosAgrupatsPerMunicipi).forEach((idMunicipi) => {
		const avisosMunicipiAgrupatsPerMeteor = _.groupBy(avisosAgrupatsPerMunicipi[idMunicipi], 'idMeteor');

		Object.keys(avisosMunicipiAgrupatsPerMeteor).forEach((idMeteor) => {
			const avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent = avisosMunicipiAgrupatsPerMeteor[idMeteor].reduce((meteorAmbUltimaData, meteor) => {
				return meteor.data > meteorAmbUltimaData.data ? meteor : meteorAmbUltimaData;
			});

			const avisEstructuraTransformada = {};
			avisEstructuraTransformada.id = avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent.id;
			avisEstructuraTransformada.idMeteor = avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent.idMeteor;
			avisEstructuraTransformada.idComarca = avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent.comarca.id;
			avisEstructuraTransformada.municipi = avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent.municipi;
			avisEstructuraTransformada.data = avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent.data;
			avisEstructuraTransformada.coordenades = avisosMunicipiAgrupatsPerMeteorReduitsAlMesRecent.coordenades;

			avisosMunicipiAgrupatsPerMeteor[idMeteor] = avisEstructuraTransformada;
		});

		avisosAgrupatsPerMunicipi[idMunicipi] = avisosMunicipiAgrupatsPerMeteor;
	});

	return avisosAgrupatsPerMunicipi;
};

const generarClustersIMarkersLeaflet = (avisosFormatMapa, clustersLayerGroup, onClickMarker) => {
	const clustersIMarkersLeaflet = {};

	Object.keys(avisosFormatMapa).forEach((codiIneMunicipi) => {
		clustersIMarkersLeaflet[codiIneMunicipi] = {
			cluster: L.markerClusterGroup({ showCoverageOnHover: false, spiderfyDistanceMultiplier: 1.5, spiderLegPolylineOptions: { weight: 1.8, color: '#222', opacity: 0.85 } }).addTo(clustersLayerGroup),
			meteors: {}
		};

		Object.keys(avisosFormatMapa[codiIneMunicipi]).forEach((idMeteor) => {
			const avis = avisosFormatMapa[codiIneMunicipi][idMeteor];
			const avisCoordenades = L.latLng(avis.coordenades.latitud, avis.coordenades.longitud);

			const iconaMeteor = L.icon({
				iconUrl: icones[idMeteor],
				iconSize: [34, 34]
			});
			const marker = L.marker(avisCoordenades, { icon: iconaMeteor });
			marker.on('click', () => onClickMarker(avis.id));

			clustersIMarkersLeaflet[codiIneMunicipi][idMeteor] = marker.addTo(clustersIMarkersLeaflet[codiIneMunicipi].cluster);
		});
	});

	return clustersIMarkersLeaflet;
};

const estilsTopoJsonComarques = { opacity: 0.2, fillOpacity: 0.2, weight: 2, color: '#0652DD' }; //blau
const generarTopoJsonComarques = (topoJsonComarquesData, avisos, capesMeteors) => {
    var capaComarques = L.geoJson(null, {
        filter: (feature) => avisos.some((avis) => avis.comarca.id === feature.properties.IDComarca && capesMeteors[avis.idMeteor]),
        style: estilsTopoJsonComarques
    });

    return omnivore.topojson.parse(topoJsonComarquesData, null, capaComarques);
};

const estilsTopoJsonMunicipis = { opacity: 0.4, fillOpacity: 0.6, weight: 2, color: '#eb2f06' }; //vermell
const generarTopoJsonMunicipis = (topoJsonMunicipisData, avisos, capesMeteors) => {
    var capaMunicipis = L.geoJson(null, {
        filter: (feature) => avisos.some((avis) => avis.municipi.codiIne === feature.properties.cm_ine_mun && capesMeteors[avis.idMeteor]),
        style: estilsTopoJsonMunicipis
    });

    return omnivore.topojson.parse(topoJsonMunicipisData, null, capaMunicipis);
};

const filtrarAvisosPerMeteorIVisualitzacioMapa = (avisos, limitsMapa, capesMeteors) => {
	const obtenirCoordenadesAvis = ({ latitud, longitud }) => L.latLng([latitud, longitud]);

	const avisosFiltrats = avisos.filter((avis) => {
		return limitsMapa.contains(obtenirCoordenadesAvis(avis.coordenades)) && capesMeteors[avis.idMeteor];
	});
	return avisosFiltrats.map((avis) => avis.id);
};

class AvisMapa extends Component {
	constructor(props) {
		super(props);
		this.state = {
			capesMeteors: {},
			topoJsonComarquesData: null,
			topoJsonMunicipisData: null,
			topojsonLoaded: false
		};
		this.onChangeMeteorSeleccionat = this.onChangeMeteorSeleccionat.bind(this);
		this.mapInitialized = false;
	}

	async componentDidMount() {
		// Carregar els fitxers JSON un sol cop
		try {
			const [comarquesResponse, municipisResponse] = await Promise.all([
				fetch(urlTopoJsonComarques),
				fetch(urlTopoJsonMunicipis)
			]);
			
			const topoJsonComarquesData = await comarquesResponse.json();
			const topoJsonMunicipisData = await municipisResponse.json();
			
			this.setState({
				topoJsonComarquesData,
				topoJsonMunicipisData,
				topojsonLoaded: true
			});
			
			// No inicialitzem el mapa aquí, ho fem a componentDidUpdate per assegurar-nos que el component està renderitzat
		} catch (error) {
			console.error('Error loading topojson data:', error);
		}
	}
	
	componentDidUpdate(prevProps, prevState) {
		// Inicialitzar el mapa un cop que les dades estiguin carregades i el component renderitzat
		if (!prevState.topojsonLoaded && this.state.topojsonLoaded && this.divMapa && !this.mapInitialized) {
			this.initializeMap();
			this.mapInitialized = true;
		}
		
		// Actualitzar el mapa quan canvien els avisos
		if (prevProps.avisos !== this.props.avisos && this.state.topojsonLoaded && this.mapa) {
			this.updateMapWithAvisos(this.props.avisos);
		}
	}
	
	initializeMap() {
		const coordenadesInicials = L.latLng(coordenadesCentreCatalunya.latitud, coordenadesCentreCatalunya.longitud);
		const ampladaPantalla = window.innerWidth;
		const nivellZoomInicial = ampladaPantalla < 600 ? 7 : 8;
		var layer = generarCapaBase();
	
		const configuracioMapa = {
			maxZoom: 13,
			minZoom: 6,
			zoom: nivellZoomInicial,
			maxBounds: [[43, -0.06], [40.37, 3.57]],
			center: coordenadesInicials,
			layers: [layer],
			attributionControl: false
		};
	
		const mapa = L.map(this.divMapa, configuracioMapa);
	
		mapa.on('zoom', () => {
			const zoomActual = mapa.getZoom();
	
			if (zoomActual > nivellZoomMostrarClusters && !mapa.hasLayer(this.leafletClusters)) {
				this.leafletClusters.addTo(mapa);
			} else if (zoomActual <= nivellZoomMostrarClusters && mapa.hasLayer(this.leafletClusters)) {
				this.leafletClusters.remove();
			}
		});
	
		mapa.on('moveend', () => {
			const limitsMapa = mapa.getBounds();
			const avisos = this.props.avisos;
			const capesMeteors = this.state.capesMeteors;
	
			const avisosFiltrats = filtrarAvisosPerMeteorIVisualitzacioMapa(avisos, limitsMapa, capesMeteors);
			this.props.avisVisualitzacioActualitzarIdsAvisosPelMapa(avisosFiltrats);
		});
	
		this.mapa = mapa;
		this.estructuresLeaflet = {};
		this.leafletClusters = L.layerGroup();
		
		// Inicialitza les capes de GeoJSON amb les dades ja carregades
		this.capaGeoJsonComarques = generarTopoJsonComarques(this.state.topoJsonComarquesData, [], []);
		this.capaGeoJsonMunicipis = generarTopoJsonMunicipis(this.state.topoJsonMunicipisData, [], []);
		
		// Actualitza el mapa amb les dades inicials si ja hi ha avisos
		if (this.props.avisos.length > 0) {
			this.updateMapWithAvisos(this.props.avisos);
		}
	}
	
	updateMapWithAvisos(avisos) {
		const avisosFormatMapa = transformarEnEstructuraMapa(avisos);
	
		const avisosAgrupatsPerMeteor = _.groupBy(avisos, 'idMeteor');
		const capesMeteors = {};
		Object.keys(avisosAgrupatsPerMeteor).forEach((idMeteor) => {
			capesMeteors[idMeteor] = true;
		});
	
		const limitsMapa = this.mapa.getBounds();
		const avisosFiltrats = filtrarAvisosPerMeteorIVisualitzacioMapa(avisos, limitsMapa, capesMeteors);
		this.props.avisVisualitzacioActualitzarIdsAvisosPelMapa(avisosFiltrats);
	
		this.setState({ ...this.state, capesMeteors });
	
		this.leafletClusters.clearLayers();
		this.estructuresLeaflet = generarClustersIMarkersLeaflet(avisosFormatMapa, this.leafletClusters, this.props.avisVisualitzacioSeleccionarAvis);
	
		// Actualitza les capas GeoJSON amb les dades ja carregades
		if (this.capaGeoJsonComarques) {
			this.capaGeoJsonComarques.remove();
		}
		this.capaGeoJsonComarques = generarTopoJsonComarques(
			this.state.topoJsonComarquesData, 
			avisos, 
			capesMeteors
		);
		this.capaGeoJsonComarques.addTo(this.mapa);
	
		if (this.capaGeoJsonMunicipis) {
			this.capaGeoJsonMunicipis.remove();
		}
		this.capaGeoJsonMunicipis = generarTopoJsonMunicipis(
			this.state.topoJsonMunicipisData, 
			avisos, 
			capesMeteors
		);
		this.capaGeoJsonMunicipis.addTo(this.mapa);
	}
	
	componentWillUnmount() {
		if (this.mapa) {
			this.mapa.stop();
			this.mapa.remove();
		}
	}
	
	async onChangeMeteorSeleccionat(idMeteor, valorMeteor) {
		const limitsMapa = this.mapa.getBounds();
		const avisos = this.props.avisos;
	
		const capesMeteors = { ...this.state.capesMeteors, [idMeteor]: valorMeteor };
	
		const avisosFiltrats = filtrarAvisosPerMeteorIVisualitzacioMapa(avisos, limitsMapa, capesMeteors);
		this.props.avisVisualitzacioActualitzarIdsAvisosPelMapa(avisosFiltrats);
	
		Object.keys(this.estructuresLeaflet).forEach((idMunicipi) => {
			const avisosMunicipi = this.estructuresLeaflet[idMunicipi];
	
			if (avisosMunicipi[idMeteor]) {
				if (valorMeteor) {
					avisosMunicipi.cluster.addLayer(avisosMunicipi[idMeteor]);
				} else {
					avisosMunicipi.cluster.removeLayer(avisosMunicipi[idMeteor]);
				}
			}
		});
	
		this.setState({ ...this.state, capesMeteors });
	
		// Actualitza les capes GeoJSON amb les dades ja carregades
		if (this.capaGeoJsonComarques) {
			this.capaGeoJsonComarques.remove();
		}
		this.capaGeoJsonComarques = generarTopoJsonComarques(
			this.state.topoJsonComarquesData, 
			avisos, 
			capesMeteors
		);
		this.capaGeoJsonComarques.addTo(this.mapa);
	
		if (this.capaGeoJsonMunicipis) {
			this.capaGeoJsonMunicipis.remove();
		}		
		this.capaGeoJsonMunicipis = generarTopoJsonMunicipis(
			this.state.topoJsonMunicipisData, 
			avisos, 
			capesMeteors
		);
		this.capaGeoJsonMunicipis.addTo(this.mapa);
	}

	render() {
		const arrayIdsMeteors = Object.keys(this.state.capesMeteors);
		const hiHaAvisos = arrayIdsMeteors.length > 0;
		const llegenda = hiHaAvisos ? <AvisMapaLlegenda idsMeteors={arrayIdsMeteors} /> : null;

		return (
			<div className='avis-mapa'>
				<div style={{ position: 'relative' }}>
					<AvisMapaSelectorMeteors meteors={this.state.capesMeteors} onChangeMeteorSeleccionat={this.onChangeMeteorSeleccionat} />
					<div className='avis-mapa-mapa' ref={(ref) => (this.divMapa = ref)}>
						<Spin className='carregant' spinning={this.props.peticioObtenirEnCurs || !this.state.topojsonLoaded} delay={RETARD_MILISEGONS_APARICIO_SPINNER} size='large'></Spin>
					</div>
					{llegenda}
				</div>
			</div>
		);
	}
}

AvisMapa.propTypes = {
	avisos: PropTypes.array,
	avisVisualitzacioSeleccionarAvis: PropTypes.func,
	avisVisualitzacioActualitzarIdsAvisosPelMapa: PropTypes.func,
	peticioObtenirEnCurs: PropTypes.bool
};

const mapStateToProps = (state) => ({
	avisos: state.avis.visualitzacio.avisos.tots,
	peticioObtenirEnCurs: state.avis.visualitzacio.avisos.peticioObtenirEnCurs
});

export default connect(
	mapStateToProps,
	{ avisVisualitzacioSeleccionarAvis, avisVisualitzacioActualitzarIdsAvisosPelMapa }
)(AvisMapa);


// WEBPACK FOOTER //
// ./src/components/avis/avisMapa.js